<style src="./ColumnEdition.scss" lang="scss"></style>
<template>
  <section class="column-edition">
    <form @submit.prevent="sendFilter" class="rowsection">
      <span class="title">Filtrar por valor</span>
      <div class="filters">
        <select
          class="cp1-small-select selection"
          v-model="filters.filterType">
          <option
            v-for="(filterType, filterTypeIdx) in filters.filterTypesByValue"
            :key="filterTypeIdx"
            :value="filterTypeIdx">{{ filterType }}</option>
        </select>
        <input
          type="text"
          v-model="filters.filterValue"
          placeholder="10"
          class="cp1-small-textbox searchtext" />
      </div>

      <div class="command">
        <button
          type="button"
          @click="cleanFilter"
          class="cp1-small-button cp1-button__ghost filterbutton">
          Limpar Filtro
        </button>
        <button
          class="cp1-small-button cp1-button__success filterbutton">
          Filtrar
        </button>

      </div>
    </form>
  </section>
</template>

<script>
// import { IconSave, IconStar } from '@/components/primitives/icons'

const FilterTypes = {
  0: 'Nenhum Filtro',
  'LIKE': 'Contém',
  'GT': 'Maior que',
  'LT': 'Menor que',
  'EQ': 'Igual a'
}

export default {
  name: 'ColumnEdition',
  components: {
    // IconStar,
    // IconSave
  },
  props: {
    columnId: {
      default: () => ({})
    },
    filterList: {
      default: () => ({})
    }
  },
  data: () => ({
    filters: {
      filterTypesByValue: { ...FilterTypes },
      filterType: '0',
      filterValue: 0
    }
  }),
  watch: {
    filterList: {
      handler () {
        this.checkFilterValue()
      },
      immediate: true
    }
  },
  methods: {
    cleanFilter () {
      this.filters.filterType = '0'
      this.filters.filterValue = null
      this.sendFilter()
    },
    sendFilter () {
      const filter = {
        columnId: this.columnId,
        filterType: this.filters.filterType,
        filterValue: this.filters.filterValue
      }
      this.$emit('filter-value', filter)
    },
    checkFilterValue () {
      this.filters.filterType = this.filterList[this.columnId].filterType
      this.filters.filterValue = this.filterList[this.columnId].filterValue
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/item-pricing/components/column-edition/ColumnEdition.vue